import * as origYup from "yup";
import {de} from "yup-locales";
origYup.setLocale(de);

export const yup = {
    ...origYup,
    number: () => origYup.number().nullable(),
    string: () => origYup.string().nullable(),
    date: () => origYup.date().nullable(),
};